<template>
    <loading :active="loading"
             :can-cancel="true"
             :is-full-page="true"></loading>
    <modalView class="z-50" v-if="address_book_open" @close-modal="address_book_open = false" :harf="false"  >
        <MyOrderLegsDetail :selectid="search_detail_id"  :s_date="s_date" :e_date="e_date"></MyOrderLegsDetail>
    </modalView>

    <article class="myo_search_area">
        <form name='form_search' id="form_search"  v-on:submit.prevent="submitForm" style="clear:both;">
            <section class="myo_condition_box">
                <div class="relative z-50">
                    <dateForm @set_s_date="set_s_date" @set_e_date="set_e_date" :isNoChangeDate=true ></dateForm>
                </div>
                <section class="flex_box_quad">
                    <memberForm @set_id="set_id" :selectid="selectid"></memberForm>
                    <divisionForm :reg_type="reg_type" @get_reg_type="get_reg_type"></divisionForm>
                </section>

                <div class="myo_accordion">
                    <div class="accordion_item">
                        <a class="accordion_tit" href="#n">{{ i18n.myoffice.myoSearchForm.searchSetting }} <span class="accordion_sub_tit">{{ i18n.myoffice.moreview }}</span>
                            <div class="bmenu x7"><span class="btop"><i class="fas fa-chevron-down"></i></span></div>
                        </a>
                        <div class="accordion_cont ">
                            <div class="w-full lg:grid lg:grid-cols-4 lg:gap-2">
                                <div class="w-full z-[14] relative">
                                    <countryForm @set_bz_cd="set_bz_cd" :bz_cd="bz_cd"></countryForm>
                                </div>
                                <div class="w-full z-[13]  relative">
                                    <orderClassification @set_ord_kind="set_ord_kind"></orderClassification>
                                </div>
                                <div class="w-full z-[12]  relative">
                                    <ordeType @set_kind_cd="set_kind_cd"></ordeType>
                                </div>
                                <div class="w-full z-[11]  relative">
                                    <transactionStatus @set_rcpt_yns="set_rcpt_yns"></transactionStatus>
                                </div>
                                <div class="z-10 col-span-4  relative">
                                    <rankForm  @setSelected="setSelected" ></rankForm>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section><!-- // myo_condition_box -->

            <div class="myo_condition_search2">
                <button type="reset" onclick="location.replace('/MyOrderLegs')" class="reset_btn">{{ i18n.myoffice.Refresh  }}</button>
                <button type="submit" class="search_btn">{{ i18n.myoffice.Search  }}</button>
            </div>
        </form>
    </article>
    <div style="height: 10px; clear:both;"></div>
    <div id="search_result">
        <div id="">
            <h4 class='order-line-name'>{{ i18n.myoffice.dashboard.Line  }} {{ ltotal }} </h4>
            <div id="search_result"  class="list-table-wrap">
                <table class="list-table">
                    <thead>
                    <tr>
                        <th>{{ i18n.myoffice.MyMember.memberId}}</th>
                        <th>{{ i18n.myoffice.MyMember.memberName}}</th>
                        <th>{{ i18n.myoffice.MyMember.step}}</th>
                        <th>{{ i18n.myoffice.MyMember.curRank}}</th>
                        <th>{{ i18n.myoffice.MyMember.mySalePv}}</th>
                        <th>{{ i18n.myoffice.MyMember.myReturnPv}}</th>
                        <th>{{ i18n.myoffice.MyMember.downSalePv}}</th>
                        <th>{{ i18n.myoffice.MyMember.downReturnPv}}</th>
                        <th>{{ i18n.myoffice.MyMember.totalSalePv}}</th>
                        <th>{{ i18n.myoffice.MyMember.viewDetail}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="center" colspan="4">{{ i18n.myoffice.total }}</td>
                        <td align="right"><span v-if="lists.length != 0">{{ formatPrice(total_pv_my,1) }}</span></td>
                        <td align="right"><span v-if="lists.length != 0">{{ formatPrice(total_pv_re,1) }}</span></td>
                        <td align="right"><span v-if="lists.length != 0"></span></td>
                        <td align="right"><span v-if="lists.length != 0">{{ formatPrice(total_pv_down_re,1) }}</span></td>
                        <td align="right"><span v-if="lists.length != 0">{{ formatPrice(total_pv_tot,1) }}</span></td>
                        <td align="right"><span v-if="lists.length != 0"></span></td>

                    </tr>
                    <tr v-for="(value) in lists" class="whitespace-nowrap" :id="value.userid"  >
                        <td v-if="value.userid" align="center" ><div class="user_menu" :data-enc_id="value.enc_id" :data-userid="value.userid" >{{ value.userid }}</div></td>
                        <td v-if="value.userid" align="center" >{{ value.username ? value.username : '' }}<i v-show="value.username" ></i></td>
                        <td v-if="value.userid" align="center" >{{ value.lv }}<i v-show="value.rank_name" ></i></td>
                        <td v-if="value.userid" align="center" >{{ value.rank_name }}<i v-show="value.rank_name" ></i></td>
                        <td v-if="value.userid" align="right">{{ formatPrice(value.pv_my,1) }}</td>
                        <td v-if="value.userid" align="right">{{ formatPrice(value.pv_re ,1) }}</td>
                        <td v-if="value.userid" align="right">{{ formatPrice(value.pv_down ,1) }}</td>
                        <td v-if="value.userid" align="right">{{ formatPrice(value.pv_down_re ,1) }}</td>
                        <td v-if="value.userid" align="right">{{ formatPrice(value.pv_tot  ,1) }}</td>
                        <td v-if="value.userid" align="right" v-on:click="searchList( value.enc_id,value.userid )">{{ i18n.myoffice.MyMember.view }}</td>

                    </tr>
                    <tr v-if="lists.length == 0">
                        <td colspan="13" style="text-align: center">
                          {{ this.list_msg }}
                        </td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>
import dateForm from '../../searchForm/dateForm.vue'
import memberForm from '../../searchForm/memberForm.vue'
import stepForm from '../../searchForm/stepForm.vue'
import divisionForm from '../../searchForm/divisionForm.vue'
import countryForm from '../../searchForm/countryForm.vue'
import orderClassification from '../../searchForm/orderClassification.vue'
import rankForm from '../../searchForm/rankForm.vue'
import ordeType from '../../searchForm/ordeType.vue'
import transactionStatus from '../../searchForm/transactionStatus.vue'
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import VueSimpleAlert from "vue3-simple-alert";
import { Tooltip } from "floating-vue";
import 'floating-vue/dist/style.css';
import modalView from "../../modalView";
import MyOrderLegsDetail from "./MyOrderLegsDetail";


export default {
    name: "MyOrderLegs",
    components : {
        dateForm,
        memberForm,
        stepForm,
        divisionForm,
        countryForm,
        orderClassification,
        rankForm,
        ordeType,
        transactionStatus,
        VPagination,
        Loading,
        VTooltip : Tooltip,
        modalView,
        MyOrderLegsDetail,
    },
    data: ()=>({
        i18n: window.i18n,
        lists : [],
        rlists : [],
        ltotal : "",
        rtotal : "",
        rank_cd : "",
        bz_cd : "",
        ord_kind : "",
        kind_cd : "",
        rcpt_yns : "",
        loading : false,
        fullPage : true,
        list_msg : "Click 'Search' to view the data",
        lbz_cd : 0,
        rbz_cd : 0,
        ltotal_bv  : 0,
        rtotal_bv  : 0,

        address_book_open : false,
        search_detail_id : "",

        total_pv_my : 0,
        total_pv_re : 0,
        total_pv : 0,
        total_pv_down : 0,
        total_pv_down_re : 0,
        total_pv_down_tot : 0,
        total_pv_tot : 0,
        s_date : "",
        e_date : "",
        reg_type : "P",
    }),
    mounted() {
        this.submitForm();
    },
    props:['selectid','search_id','selectiddecrypt'],
    methods : {
        submitForm : function (event){
            // event.preventDefault();
            this.loading = true;
            axios.post(window.Laravel.back_url+'/api/getOrderLegs',{
                s_date : this.s_date,
                e_date : this.e_date,
                level : 2,
                sid : this.selectiddecrypt != "" && search_id.value == "" ? this.selectiddecrypt : search_id.value,
                bz_cd : this.bz_cd,
                ord_kind : this.ord_kind,
                kind_cd : this.kind_cd,
                rcpt_yns : this.rcpt_yns,
                rank_cd : this.rank_cd,
                left_search : 1,
                reg_type : this.reg_type
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response => {
                this.loading = false;
                this.lists = response.data.list;
                this.ltotal = response.data.total;
                this.lbz_cd = response.data.bz_cd;
                this.total_pv_my = response.data.total_pv_my;
                this.total_pv_re = response.data.total_pv_re;
                this.total_pv = response.data.total_pv;
                this.total_pv_down = response.data.total_pv_down;
                this.total_pv_down_re = response.data.total_pv_down_re;
                this.total_pv_down_tot = response.data.total_pv_down_tot;
                this.total_pv_tot = response.data.total_pv_tot;
                if(this.ltotal == 0 && this.rtotal == 0){
                    VueSimpleAlert.alert("There are no search results","","",{});
                    this.list_msg = "No data";
                    this.sid_name = "";
                }

            });

        },
        searchList(stduser,userid){
            this.address_book_open = true;
            this.search_detail_id = stduser;

            $(".whitespace-nowrap").removeClass("!bg-orange-400");
            $(".whitespace-nowrap").removeClass("!text-white");

            $("#"+userid).addClass("!bg-orange-400");
            $("#"+userid).addClass("!text-white");

/*

            event.preventDefault();
            this.loading = true;
            axios.post(window.Laravel.back_url+'/api/getOrderLegs',{
                s_date : this.s_date,
                e_date : this.e_date,
                level : 2,
                sid : stduser,
                bz_cd : this.bz_cd,
                ord_kind : this.ord_kind,
                kind_cd : this.kind_cd,
                rcpt_yns : this.rcpt_yns,
                rank_cd : this.rank_cd,
                left_search : 2,
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response => {
                this.loading = false;
                this.rlists = response.data.list;
                this.rtotal = response.data.total;
                this.rbz_cd = response.data.bz_cd;
                this.rtotal_bv = response.data.total_bv;

                if(this.ltotal == 0 && this.rtotal == 0){
                    VueSimpleAlert.alert("There are no search results","","",{});
                    this.list_msg = "No data";
                    this.sid_name = "";
                }

            });
*/

        },
        setSelected(rank){
            this.rank_cd = "";
            rank.forEach((value, index) => {
                this.rank_cd += value.id
                if(rank.length != index+1){
                    this.rank_cd += ",";
                }
            });
        },
        updatePageHandler(page){
            //this.page = page;
        },
        notCheck(id){
            return this.order != id ? true : false;
        },
        asconCheck(id){
            return this.order == id && this.sort == "asc" ? true : false;
        },
        descCheck(id){
            return this.order == id && this.sort == "desc" ? true : false;
        },
        reSortArray(id){
            this.order = id;
            this.sort = this.sort == "asc" ? "desc" : "asc";
            $("#submit").click();

        },
        set_id(sid){
            this.select_id = sid;
        },
        set_s_date(s_date){
            this.s_date = s_date;
        },
        set_e_date(e_date){
            this.e_date = e_date;
        },
        set_date_type(date_type){
            this.date_type = date_type;
        },
        set_bz_cd(bz_cd){
            this.bz_cd = bz_cd;
        },
        set_ord_kind(ord_kind){
            this.ord_kind = ord_kind;
        },
        set_kind_cd(kind_cd){
            this.kind_cd = kind_cd;
        },
        set_rcpt_yns(rcpt_yns){
            this.rcpt_yns = rcpt_yns;
        },
        formatPrice(value,digit) {
            let val = (value/1).toFixed(digit).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        get_reg_type (value) {
          this.reg_type = value;
        },

    }
}
</script>

<style>
#search_result:after { content: ""; display: block; clear:both;}
#orders-left { width:calc(50% - 5px); float:left;}
#orders-right { width:calc(50% - 5px); float:right;}
.fal.fa-search {font-size: 16px; padding:3px; border:1px solid #dadada;}
@media    all and (min-width:991px ) and (max-width:1000px) {
    #orders-left { width:calc(100%); float:none; margin-bottom: 20px;}
    #orders-right { width:calc(100%); float:none;}
}

@media    all and (max-width:770px) {
    #orders-left { width:calc(100%); float:none; margin-bottom: 20px;}
    #orders-right { width:calc(100%); float:none;}
}

/*테이블 타이블 */
.order-line-name { background: #272c33; color:#fff; padding:10px; margin: 0;}

</style>
